import * as yup from 'yup';

export default yup
  .object({
    manufacturer_id: yup.number().required('Marca é obrigatório'),
    model: yup.string().required('Modelo é obrigatório'),
    serial_number: yup.string().required('Chassi do equipamento é obrigatório')
  })
  .required();
